import {
  avatarsFromAvatarUrl,
  getNonPublicIfAvailable,
  type MemberWithNonPublicInformation,
} from '@trello/business-logic/member';
import { dangerouslyConvertPrivacyString } from '@trello/privacy';

/**
 * Extracts avatar data from a member object using the non-public avatar URL if available.
 * This follows the same pattern used in the member avatar components.
 *
 * @param member - The member object containing avatar information
 * @returns Avatar data for different sizes or undefined if no avatar URL is available
 */
export function getMemberAvatars(member: MemberWithNonPublicInformation) {
  const avatarUrl = getNonPublicIfAvailable(member, 'avatarUrl');
  return avatarUrl
    ? avatarsFromAvatarUrl(dangerouslyConvertPrivacyString(avatarUrl))
    : undefined;
}

export const memberAvatarUtils = {
  getMemberAvatars,
};
